import { site } from "../content";

let initialized = false;

export function initAnalytics() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  const { ga4, googleAds, metaPixel } = site.tracking;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtagStub() {
      window.dataLayer.push(arguments);
    };

  if (ga4 || googleAds) {
    const id = ga4 || googleAds;
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(script);
    window.gtag("js", new Date());
    if (ga4) window.gtag("config", ga4);
    if (googleAds) window.gtag("config", googleAds);
  }

  if (metaPixel) {
    /* Meta Pixel — ativado apenas quando o ID for configurado em content.js */
    const fb = (window.fbq =
      window.fbq ||
      function fbqStub() {
        window.fbq.queue.push(arguments);
      });
    fb.queue = fb.queue || [];
    fb.loaded = true;
    fb.version = "2.0";
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);
    window.fbq("init", metaPixel);
    window.fbq("track", "PageView");
  }
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  try {
    if (window.gtag) window.gtag("event", name, params);
    if (window.fbq) window.fbq("trackCustom", name, params);
    if (window.dataLayer) window.dataLayer.push({ event: name, ...params });
  } catch {
    /* analytics nunca pode quebrar a navegação */
  }
}
